import { Img } from 'react-image';
import { useLocation } from 'react-router-dom';
import { useThemeContext } from 'src/context/ThemeProvider';
import SignupWrapper from './SignupWrapper';
import SigninWrapper from './SigninWrapper';
import { useMediaQuery } from '@mui/material';
import DemoWrapper from './DemoWrapper';
import classNames from 'classnames';

interface Props {
	bookADemo?: boolean;
}

const UniversityAuthSideInfo = ({ bookADemo }: Props) => {
	const location = useLocation();
	const { themeMode } = useThemeContext();
	const isMobile = useMediaQuery('(max-width:960px)');
	const signInurl = location.pathname?.split('?')[0];

	const companyLogos = [
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/c_1_ca6afa4797.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/c_2_c6379181ce.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/c_3_a50a5c7835.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/c_4_a0efd84f1f.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/c_5_7164421785.png',
	];

	const pointersData = [
		{
			title: 'Comparative Student Benchmarking',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/uni_point_1_b0fcecf46c.png',
			description: 'Evaluate and benchmark your students against peers, aligning with industry standards.',
		},
		{
			title: 'Industry-Driven Masterclasses',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/uni_point_2_99df1eaa33.png',
			description:
				'Enhance student employability with expert-led, focused on excelling in interviews, assessments, and personal branding.',
		},
		{
			title: 'Extensive Company Network',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/uni_point_3_84ccc8901f.png',
			description: 'Grant students access to placement drives and pre-placement talks with 100+ leading companies.',
		},
	];

	return (
		<div
			className={`min-h-[100dvh] w-[100%] overflow-hidden flex flex-col justify-between dark:bg-[#1f3343]  bg-[#F7F9FB] md:bg-[#FFF] relative isolate`}
		>
			<img
				alt=""
				className="absolute w-full h-full z-[-1]"
				src="https://masai-website-images.s3.ap-south-1.amazonaws.com/auth_bg_00f757f54a.png"
			/>
			{(signInurl === '/auth/signin' ||
				signInurl === '/auth/bookADemo' ||
				signInurl === '/auth/register' ||
				signInurl === '/auth/email-verification' ||
				signInurl === '/auth/phone-verification' ||
				signInurl === '/auth/change-phone' ||
				signInurl === '/auth/change-email') && (
					<div
						className={classNames(
							'flex flex-1 flex-col md:min-h-[100dvh] overflow-auto',
							location?.pathname.includes('bookADemo') ? 'pb-[72px]' : '',
						)}
					>
						<div className="flex-1 max-w-[90%] mx-[5%] h-full flex flex-col">
							<Img
								loading="lazy"
								className={`block pt-[20px] pb-[18px] pl-[6px] ${bookADemo ? '' : 'md:hidden'}`}
								src={
									themeMode === 'dark'
										? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
										: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
								}
								width={bookADemo && !isMobile ? '142' : '101'}
								height={bookADemo && !isMobile ? '48' : '36'}
								alt="logo"
							/>

							<div
								className={`text-[32px] md:text-[54px] font-inter font-[700] dark:text-[#fff] !text-[#1F3343] leading-[40px] md:leading-[56px]  ${!bookADemo ? 'md:mt-[50px]' : 'md:mt-[20px]'
									}`}
							>
								Identify{' '}
								<span className="inline-flex greenish-gradient-text bg-clip-text text-transparent">
									{' '}
									job-ready students
								</span>{' '}
								with precision
							</div>
							<div className="mt-4 md:mt-6 text-base font-[500] text-[#555770]">
								Looking to pinpoint top-performing, career-ready students? We've got the tools you need.
							</div>

							<div className="flex items-center justify-between pt-3">
								<div className="flex flex-col gap-4 md:gap-8 xl:pl-8 py-4 md:py-10 max-w-[584px]">
									{pointersData.map((pointer, index) => (
										<div key={index} className="flex items-start gap-2 md:gap-4">
											<img
												className="min-w-[34px] md:min-w-[48px] min-h-[34px] md:min-h-[48px] w-[34px] md:w-[48px] h-[34px] md:h-[48px]"
												src={pointer.icon}
												alt={pointer.title}
											/>
											<div>
												<h3 className="text-sm md:text-lg font-inter font-[700] text-[#28293D]">{pointer.title}</h3>
												<p className="text-xs md:text-sm font-inter font-[500] text-[#555770]">{pointer.description}</p>
											</div>
										</div>
									))}
								</div>
							</div>

							<div
								className={classNames(
									`md:hidden mt-[auto] mx-[-16px]`,
									location?.pathname.includes('bookADemo')
										? 'fixed inset-x-0 bottom-0 z-[1] shadow-[0px_-2px_4px_0px_rgba(0,_0,_0,_0.15)]'
										: '',
								)}
							>
								{location?.pathname.includes('register') ? (
									<SignupWrapper showFormUiOnly={true} />
								) : location?.pathname.includes('bookADemo') ? (
									<DemoWrapper />
								) : (
									<SigninWrapper showFormUiOnly={true} />
								)}
							</div>

							<img
								src="https://masai-website-images.s3.ap-south-1.amazonaws.com/bg_gradiant_abe6e9e32e.png"
								alt=""
								className="absolute bottom-[-80px] pointer-events-none inset-x-0 z-[-1] w-full h-[369.32px] max-h-[369.32px] max-w-[398px] mx-auto"
							/>

							<div className="relative py-4 mb-10 mt-3 text-center md:text-left box-border flex flex-col gap-7 overflow-hidden">
								<div>100+ universities trust LevelUp.</div>
								<div className="flex flex-wrap justify-center md:justify-evenly gap-3">
									{companyLogos?.map(el => <Img key={el} src={el} className="max-w-[94px]" />)}
								</div>
							</div>
						</div>
					</div>
				)}
		</div>
	);
};

export default UniversityAuthSideInfo;
